import type { PrayerTimeSet } from '@bonyaan/prayer-times';
import type { Scheme, SchemeChoice } from './types';

function minutes(time: string): number {
  const [h, m] = time.split(':').map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}

/**
 * 'auto' follows the sun the way the app already understands it: Day once
 * Fajr has come in, Night again from Maghrib. No extra location data needed
 * beyond what the prayer times already require.
 *
 * Far enough north, Maghrib lands after midnight and so reads as EARLIER in
 * the day than Fajr. Comparing the two clock times directly made every hour of
 * such a day count as after Maghrib, so Reykjavik in June was night around the
 * clock; the daylight window wraps instead.
 */
export function resolveScheme(
  choice: SchemeChoice,
  times: PrayerTimeSet,
  now: Date = new Date(),
): Scheme {
  if (choice !== 'auto') return choice;

  const fajr = minutes(times.fajr);
  const maghrib = minutes(times.maghrib);
  const at = now.getHours() * 60 + now.getMinutes();

  const isDay = maghrib > fajr ? at >= fajr && at < maghrib : at >= fajr || at < maghrib;
  return isDay ? 'day' : 'night';
}
